import {useState, useRef} from 'react';
import {Select, Tag, Popover} from 'antd';
import {PurchaseOrderStatusType, getOptions} from "../../api/Constants";
import {updatePurchaseOrderState} from "../../api/Api";

export const PurchaseOrderStateWidget = ({purchaseOrder, onRefresh, onApiFail, isFulfillment, props}) => {
    const [active, setActive] = useState(false);
    let options;

    const inputRef = useRef(null);

    // Quick insecure implementation
    if (isFulfillment) {
        const labels = PurchaseOrderStatusType.Label;
        options = [
            {
                value: PurchaseOrderStatusType.Created,
                label: labels[PurchaseOrderStatusType.Created]
            },
            {
                value: PurchaseOrderStatusType.Fulfillment,
                label: labels[PurchaseOrderStatusType.Fulfillment]
            },
            {
                value: PurchaseOrderStatusType.Complete,
                label: labels[PurchaseOrderStatusType.Complete]
            }
        ]
    } else {
        options = getOptions(PurchaseOrderStatusType)();
    }

    const onSelect = (val) => {
        setActive(false);
        if (val === purchaseOrder.state) {
            return;
        }
        updatePurchaseOrderState(purchaseOrder.id, val).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onBlur = () => {
        setActive(false);
    }

    const onClick = () => {
        setActive(true);
        setTimeout(() => {
            inputRef.current.focus();
        }, 20)
    }

    let tagColor = "#108ee9";
    let popOverContent;
    switch (purchaseOrder.state) {
        case PurchaseOrderStatusType.Created:
            tagColor = "#108ee9";
            popOverContent = "Newly Created.  Set state to Fulfillment to begin fulfillment process"
            break;
        case PurchaseOrderStatusType.Fulfillment:
            popOverContent = "In progress at Fulfillment.  Set state to Complete once all items have been fulfilled"
            tagColor = "#f55442";
            break;
        case PurchaseOrderStatusType.Complete:
            popOverContent = "All items complete.   Set state to Verified once all inventory has been verified and added."
            tagColor = "#0ea133";
            break;
        case PurchaseOrderStatusType.Verified:
            popOverContent = "All work has been completed and verified."
            tagColor = "#8f8f8f";
            break;
        default:
    }

    if (active) {
        return <div>
            <Popover content={popOverContent}>
            <Select ref={inputRef} value={purchaseOrder.state} options={options} onSelect={onSelect} onBlur={onBlur} popupMatchSelectWidth={false}/>
            </Popover>
        </div>
    } else {
        return <Popover content={popOverContent}>
            <div onClick={onClick} style={{cursor: 'pointer'}}>
                <Tag color={tagColor}>{PurchaseOrderStatusType.Label[purchaseOrder.state]}</Tag>
            </div>
        </Popover>
    }
}